<script setup lang="ts">
import Page from '@/templates/Harmon/ui/Page/Page.vue';
import Harmon from '@/templates/Harmon/index.vue';
import FilesTable from '@/components/Files/Table/FilesTable.vue';
import FileCreateModal from '@/components/Files/Form/FileCreateModal.vue';
</script>

<template>
  <Harmon>
    <Page title="Files">
      <template #header>
        <FileCreateModal />
      </template>
      <template #content>
        <FilesTable />
      </template>
    </Page>
  </Harmon>
</template>
